import React from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { IEmployee } from '@entities/myTeam/model/types';

import cls from './EmployeeCard.module.css';
import {
    EmployeeAvatar,
    EmployeeRegistrationStatus,
    EmployeePhone,
    EmployeePosition,
    EmployeeEmail,
    EmployeeCardTitle,
} from './ui';

interface EmployeeCardProps {
    classes?: string;
    employee: IEmployee;
    employeeActionsComponent?: React.ReactNode;
    currentEmployeeId: IEmployee['id'];
    deletingEmployee: boolean;
    currentClickedId: IEmployee['id'];
}

export const EmployeeCard = ({
    classes,
    employee,
    employeeActionsComponent,
    currentEmployeeId,
    deletingEmployee,
    currentClickedId,
}: EmployeeCardProps) => {
    const { avatar, position, name, email, phone, isPending, id } = employee;
    const { t } = useTranslation();

    const employeeName =
        currentEmployeeId === id ? `${name} (${t('EmployeeCard.title.you')})` : name;

    return (
        <div
            className={classNames(cls.EmployeeCard, [classes], {
                [cls.deleting]: deletingEmployee && id === currentClickedId,
            })}
            data-employer-id={id}
        >
            {employeeActionsComponent && employeeActionsComponent}
            <EmployeeAvatar avatar={avatar} />
            <div className={cls.info}>
                <EmployeePosition position={position} />
                <EmployeeCardTitle cardTitle={employeeName} />
                {/* <EmployeeCardTitle cardTitle={employeeName} /> */}
                {name != email && <EmployeeEmail name={name} email={email} />}
                {phone && <EmployeePhone phone={phone} />}
                <EmployeeRegistrationStatus isPending={isPending} />
            </div>
        </div>
    );
};
